import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'IrisGoogleAdsLazy',
        path: () => path.join(__dirname, './GoogleAds'),
        resolve: () => require.resolveWeak('./GoogleAds'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "IrisGoogleAdsLazy" */ './GoogleAds')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);

/*
import LazyRender from 'react-lazyload';
const LazyComponent = universal(universalImport({
* Here we need to patch LazyRender, since it should render the first visible components on server and return them to client
* Let's say we have breadcrumbs, visnav, gallerygrid, footer on the page. Then on server we need to say something like "Give us all that you rendered for 1000px height (based on a user agent possibly)". Then server would render only breadcrumbs and visnav, for example, because each of that components have height property as 400 and 600 px, for example (including offset also). Then we return on client our IrisBreadcrumbsLazy.jsx file and IrisVisNavLazy.jsx files only since only that would be part of initial rendering on client.
*
* But for bots because of seo purposes we would still need to render the full content on server and since codebase has to be the same in such cases we would need to explicitly say that this is a bot and we don't need LazyRender component to be here
* __IS_BOT__ is the preferred way for that because we already have couple of requirements to have different components for bots only like Hamburger Menu which is pre-rendered. The same approach we could use here.
* !__IS_BOT__ && props.deviceType.isMobile
*
* */
// export default props => props.deviceType.isMobile ? (  // eslint-disable-line
//     <LazyRender height={300} offset={500} once throttle={200}>
//         <LazyComponent {...props}/>
//     </LazyRender>
// ) : <LazyComponent {...props}/>;
